import * as React from 'react'
import {Redirect, Route, RouteComponentProps, RouteProps} from 'react-router'

export interface IProps extends RouteProps {
  /** redirects if `false`, renders like a normal Route if `true` */
  isAccessible: boolean
  /** where to redirect to if route not accessible */
  redirectTo: string
  /** return value of fn sets the history state, useful for storing the path of the referrer */
  redirectState?: (routeComponentProps: RouteComponentProps<void>) => any
}

/**
 * PrivateRoute is useful for restricting user access to certain paths.
 * PrivateRoute behaves the same as a react-router Route when `isAccessible` is `true`.
 * If `isAccessible` is false, PrivateRoute will redirect the user (usually to an auth page).
 *
 * NOTE: PrivateRoute must be a Component (not PureComponent) to have access to the
 * shouldComponentUpdate lifecycle hook to update when react-router location changes.
 */
export class PrivateRoute extends React.Component<IProps, {}> {
  public render() {
    const { isAccessible, redirectTo, redirectState, ...restProps } = this.props
    if (!isAccessible) {
      const routeRedirect = (props: RouteComponentProps<void>) => (
        <Redirect to={{
          pathname: redirectTo,
          state: redirectState && redirectState(props),
        }}/>
      )
      const { component, ...finalProps } = restProps // tslint:disable-line no-unused-variable
      return <Route {...finalProps} render={routeRedirect} />
    }
    return <Route {...restProps} />
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/PrivateRoute/PrivateRoute.tsx